import React, { useState, useEffect,useRef,useMemo } from 'react';
// @mui material components
// import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
// import Box from "@mui/material/Box";
// import TextField from "@mui/material/TextField";
// import Button from "@mui/material/Button";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { DialogContentText } from "@mui/material";


import Backdrop from '@mui/material/Backdrop';
// import CircularProgress from '@mui/material/CircularProgress';

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { url, urlLive, fileUploadUrl } from "../../constant";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import { Grid, Typography, Box, FormControl, FormControlLabel, Checkbox,Input, InputLabel, Select, MenuItem, TextField, Stack, Button, CircularProgress,OutlinedInput  } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb'; // Import the locale for British English
import * as XLSX from 'xlsx';
import Link from '@mui/material/Link';
import LinkIcon from '@mui/icons-material/Link';
import AttachFileIcon from '@mui/icons-material/AttachFile';

import { useLocation, useNavigate } from 'react-router-dom';
import { get } from 'jquery';


function Tables() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [requests, setRequests] = useState([]);  // Stores the requests data
  const [requestName, setRequestName] = useState("");  // Stores the new request name
  const [errors, setErrors] = useState({ name: "" });

  // Dialog states for delete and edit confirmation
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteRequestId, setDeleteRequestId] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editRequestId, setEditRequestId] = useState(null);
  const [currentPageIndex, setCurrentPageIndex] = useState(0); // Manage pagination state

  // New Request submit fields
  const [type, setType] = React.useState('');
  const [typeName, setTypeName] = React.useState('');
  const [category, setCategory] = React.useState('');
  const [categoryName, setCategoryName] = React.useState('');
  const [company, setCompany] = React.useState('');
  const [companyName, setCompanyName] = React.useState('');
  const [location, setLocation] = React.useState('');
  const [experienceYears, setExperienceYears] = React.useState('');
  const [dailyRate, setDailyRate] = React.useState('');
  const [fullRemote, setFullRemote] = React.useState(false);
  const [longTerm, setLongTerm] = React.useState(false);
  const [dateStart, setDateStart] = React.useState(null);
  const [dateEnd, setDateEnd] = React.useState(null);
  const [publishDate, setPublishDate] = React.useState(null);
  const [title, setTitle] = React.useState('');
  const [description, setDescription] = React.useState('');

  const [linkUrl, setlinkUrl] = React.useState('');
  const [linkDescription, setlinkDescription] = React.useState('');
  
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState('');
  const [successMessage, setSuccessMessage] = React.useState('');
  const [companies, setCompanies] = React.useState([]);
  const [categories, setCategories] = React.useState([]);
  // const [itDev, setItDev] = React.useState([]);
  const [selectItDev, setSelectItDev] = React.useState(true);
  const [selectItDevName, setSelectItDevName] = React.useState("");
  const [requestTypes, setRequestTypes] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const inputFile = useRef(null);
  const [attachmentName, setAttachmentName] = useState('');
  const [attachment, setAttachment] = useState(null);
  const [oldattachment, setoldAttachment] = useState(null);
  const [isEmailEnabled, setIsEmailEnabled] = React.useState(false); // State for email toggle

  // const serverUrl = "http://localhost:8000"; 

  // Add loading states
  const [loading, setLoading] = useState(false);  // For fetching categories
  const [formLoading, setFormLoading] = useState(false);  // For form submission

  const navigate = useNavigate(); // Initialize the navigate function
  const locations = useLocation(); // Get the current URL location
  const queryParams = new URLSearchParams(locations.search); // Extract query parameters
  const activeTab = queryParams.get('activeTab'); // Get 'activeTab' query parameter

  //  console.log(activeTab == null ? 0 : activeTab);

  // Get user data from localStorage (user ID)
  const userData = localStorage.getItem('user');
  // alert(userData);
  const user = userData ? JSON.parse(userData).user : null;
  // console.log('user', user.IdUser);
  const IsAdminPlatform = user ? user.IsAdminPlatform : null;
  // alert(IsAdminPlatform);

  // console.log(IsAdminPlatform);

  // Update window width on resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize); // Cleanup on unmount
  }, []);

  // Condition for styles
  const shouldHide = windowWidth <= 425 ? { display: 'none' } : { visibility: 'hidden' };
  const mtValue2 = windowWidth > 425 ? 2 : 0; // Set margin-top to 2 when the window width is above 425px, else 0.
  const mtValue3 = windowWidth > 425 ? 3 : 0; // Set margin-top to 2 when the window width is above 425px, else 0.

  const itDev = [
    { id: 1, name: "True" },
    { id: 2, name: "False" }
  ];

  useEffect(() => {

    if (activeTab != null) {
      setSelectedTab(parseInt(activeTab));
    }

  }, [activeTab]);

  // Fetch requests when the component mounts
  useEffect(() => {

    // const requestOptions = {
    //   method: "GET",
    //   redirect: "follow"
    // };

    // fetch(`${url}auth/get-requests`, requestOptions)
    //   .then((response) => response.json())
    //   .then((result) => {
    //     if (result.message === "Requests retrieved successfully.") {
    //       setRequests(result.data);  // Set the fetched requests data
    //     }
    //   })
    //   .catch((error) => console.error("Error fetching requests:", error));

    getRequests();

  }, []);  // Empty dependency array to run only once when the component mounts


  const getRequests = () => {

    setLoading(true);  // Show loader while fetching data
    const requestOptions = {
      method: "GET",
      redirect: "follow"
    };

    fetch(`${url}auth/get-requests`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.message === "Requests retrieved successfully.") {
          setRequests(result.data);  // Set the fetched requests data
        }
      })
      .catch((error) => console.error("Error fetching requests:", error))
      .finally(() => {
        setLoading(false);  // Hide loader after fetching
      });

  };

  // Function to handle file change
  const handleFileChange = (e) => {
    const file = e.target.files[0]; // Get the first selected file
    console.log("file", file);
    if (file) {
      // alert(file.name);
      setAttachmentName(file.name);
      setAttachment(file); // Store the file in state
    }
  };

  // const exportToExcel = (columns, rows) => {
  //   // Prepare data for export
  //   const data = rows.map(row => {
  //     const rowData = {};
  //     columns.forEach(col => {
  //       rowData[col.Header] = row[col.accessor];
  //     });
  //     return rowData;
  //   });

  //   // Create a worksheet from the data
  //   const ws = XLSX.utils.json_to_sheet(data);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, 'DataTable');

  //   // Write the workbook to a file
  //   XLSX.writeFile(wb, 'DataTable.xlsx');
  // };

  // const exportToExcel = () => {
  //   const data = rows.map(row => {
  //     const rowData = {};
  //     // columns.forEach(col => {
  //     //   rowData[col.Header] = row[col.accessor];
  //     // });
  //     // return rowData;

  //     columns.forEach(col => {

  //       // Skip the "Action" column
  //       if (col.Header === "Actions") {
  //         return;
  //       }

  //       // Check if the column is a React component or a string/primitive value
  //       const value = row[col.accessor];
  //       // console.log(value);

  //       // Only store the value if it's not a React component
  //       if (React.isValidElement(value)) {

  //         if (value.type.name === 'FullRemoteLabel') {

  //           rowData[col.Header] = value.props.fullRemote === 1 ? "Remote" : (value.props.fullRemote === 0 ? "On-site" : "Unknown");  // Extract the text content of the component
  //         } else if (value.type.name === 'LongTermLabel') {

  //           rowData[col.Header] = value.props.longTerm === 1 ? "Long-Term" : (value.props.longTerm === 0 ? "Short-Term" : "Unknown");  // Extract the text content of the component

  //         } else {

  //           rowData[col.Header] = value.props.children;  // Extract the text content of the component

  //         }


  //       } else {
  //         rowData[col.Header] = value;  // Store the raw value (string, number, etc.)
  //       }

  //     });

  //     return rowData;

  //   });

  //   // console.log(data);
  //   // return;

  //   const ws = XLSX.utils.json_to_sheet(data);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, 'DataTable');

  //   // Get the current date and format it as "YYYY-MM-DD"
  //   const currentDate = new Date();
  //   const formattedDate = currentDate.toISOString().split('T')[0]; // Formats as "YYYY-MM-DD"

  //   // Generate the file name with the current date
  //   const fileName = `ShareITalents_${formattedDate}.xlsx`;

  //   // Write the workbook to a file with the dynamic file name
  //   XLSX.writeFile(wb, fileName);

  // };

  const exportToExcel = () => {

    const rows = requests.map(row => {
      const rowData = {};

      var DateStartAvailable = row.DateStartAvailable;
      if (DateStartAvailable) { DateStartAvailable = dayjs(DateStartAvailable).format('DD-MM-YYYY'); }

      var DateEndAvailable = row.DateEndAvailable;
      if (DateEndAvailable) { DateEndAvailable = dayjs(DateEndAvailable).format('DD-MM-YYYY'); }

      var PublishDate = row.PublishDate;
      if (PublishDate) { PublishDate = dayjs(PublishDate).format('DD-MM-YYYY'); }

      // Add fields to rowData
      rowData["#"] = row.IdRequest;
      rowData["Titolo"] = row.Title;
      rowData["Descrizione"] = row.Description;
      rowData["Collegamento URL"] = row.LinkUrl;
      rowData["Descrizione Collegamento"] = row.LinkDescription;
      rowData["Azienda"] = row.CompanyName;
      rowData["Categoria"] = row.CategoryName;
      rowData["Tipo Richiesta"] = row.TypeName;
      rowData["Location"] = row.Location;
      rowData["Full remote"] = row.FullRemote === 1 ? "Remote" : "On-site";
      rowData["Anni di esperienza"] = row.ExperienceYears;
      rowData["Rate giornaliero"] = row.DailyRate;
      rowData["Data inizio disponibilità"] = DateStartAvailable;
      rowData["Data fine disponibilità"] = DateEndAvailable;
      rowData["Lungo termine"] = row.LongTerm === 1 ? "Long-Term" : "Short-Term";
      rowData["Data pubblicazione"] = PublishDate;

      return rowData;
    });

    // Create a worksheet from the data
    const ws = XLSX.utils.json_to_sheet(rows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'DataTable');

    // Get the current date and format it as "YYYY-MM-DD"
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split('T')[0]; // Format as "YYYY-MM-DD"

    // Generate the file name with the current date
    const fileName = `ShareITalents_${formattedDate}.xlsx`;

    // Write the workbook to a file with the dynamic file name
    XLSX.writeFile(wb, fileName);
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  // Fetch company and category options
  React.useEffect(() => {
    fetchCompanies();
    fetchCategories();
    fetchRequestTypes();
  }, []);

  React.useEffect(() => {
    getEmailNotificationStatus1();
  }, []);

  const fetchCompanies = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${url}auth/get-companies`);
      const data = await response.json();
      setCompanies(data.companies || []);

    } catch (error) {
      console.error("Error fetching companies:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCategories = async () => {

    try {
      setIsLoading(true);
      const response = await fetch(`${url}auth/request-categories`);
      const data = await response.json();
      setCategories(data.categories || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setIsLoading(false);
    }

  };

  const fetchRequestTypes = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(`${url}auth/get-request-types`);
      const data = await response.json();
      setRequestTypes(data.data || []);
    } catch (error) {
      console.error("Error fetching request types:", error);
    } finally {
      setIsLoading(false);
    }

  };

  // const handleTypeChange = (event) => {
  //   setType(event.target.value);
  // };

  // const handleCategoryChange = (event) => {
  //   setCategory(event.target.value);
  // };

  // const handleCompanyChange = (event) => {
  //   setCompany(event.target.value);
  // };


  const handleTypeChange = (event) => {
    // Get the selected IdRequestType from the event
    const selectedId = event.target.value;

    // Find the corresponding RequestType from the requestTypes array
    const selectedType = requestTypes.find((type) => type.IdRequestType === selectedId);
    console.log(selectedType);

    setSelectItDev(selectedType.ItDev);

    // Set the type and typeName state values
    setType(selectedId);
    setTypeName(selectedType ? selectedType.RequestType : "");  // If found, set the RequestType; else set an empty string
    console.log(selectedType.RequestType);

  };

  const handleItDevChange = (event) => {
    // Get the selected IdRequestType from the event
    const selectedId = event.target.value;

    // Find the corresponding RequestType from the requestTypes array
    const selectedItDev = itDev.find((type) => type.id === selectedId);

    // Set the type and typeName state values
    setSelectItDev(selectedItDev.name == "True" ? true : false);


    // console.log("SelectItDev = ",selectItDev);

  };


  const handleCategoryChange = (event) => {
    // Get the selected IdRequestCategory from the event
    const selectedId = event.target.value;

    // Find the corresponding RequestCategory from the categories array
    const selectedCategory = categories.find((cat) => cat.IdRequestCategory === selectedId);

    // Set the category and categoryName state values
    setCategory(selectedId);
    setCategoryName(selectedCategory ? selectedCategory.RequestCategory : ""); // If found, set the RequestCategory; else set an empty string
  };

  const handleCompanyChange = (event) => {
    // Get the selected IdCompany from the event
    const selectedId = event.target.value;

    // Find the corresponding CompanyName from the companies array
    const selectedCompany = companies.find((comp) => comp.IdCompany === selectedId);

    // Set the company and companyName state values
    setCompany(selectedId);
    setCompanyName(selectedCompany ? selectedCompany.CompanyName : ""); // If found, set the CompanyName; else set an empty string
  };


  const handleDateStartChange = (newValue) => {
    setDateStart(newValue);
  };

  const handleDateEndChange = (newValue) => {
    setDateEnd(newValue);
  };

  const handlePublishDateChange = (newValue) => {
    setPublishDate(newValue);
  };

  // Event Handlers
  const handleChange = (setter) => (event) => setter(event.target.value);
  const handleCheckboxChange = (setter) => (event) => setter(event.target.checked);


  // Form validation
  const validateForm = () => {
    //  alert(category);
    const newErrors = {};

    // Validate required fields
    // if (!title) newErrors.title = "Title is required.";


    if (!type) newErrors.type = "Tipologia è obbligatorio";
    // if (!category) newErrors.category = "Category is required.";
    if (!category) newErrors.category = "Categoria è obbligatorio";
    // Check if title is provided
    if (!title) {
      // newErrors.title = "Title is required.";
      newErrors.title = "Titolo è obbligatorio";
    }
    if (!description) {
      // newErrors.description = "Description is required.";
      newErrors.description = "Descrizione è obbligatorio";
    }
    // alert(newErrors);
    // Check if title has at least 60 characters
    // else if (title.length < 60) {
    //   newErrors.title = "Title is invalid! The minimum length should be 60 characters.";
    // } 

    // if(linkUrl){
    //   var urlPattern = /^(https?:\/\/)([\w-]+(\.[\w-]+)+)(\/[\w-./?%&=]*)?$/i;
    //   if(!urlPattern.test(linkUrl)){
    //     newErrors.linkUrl = "Si prega di digitare un URL valido nel campo URL collegamento";
    //   }
    // }

    let updateUrl = linkUrl;

    // Agar https:// ya http:// nahi diya gaya ho, toh https:// add karo
    if (linkUrl && !/^https?:\/\//i.test(linkUrl)) {
      // Agar value hai aur https:// ya http:// nahi diya gaya, toh add karo
      updateUrl = 'https://' + linkUrl;
    }


    if (linkUrl) {

      // Sirf agar value hai tab validate karo
      var urlPattern = /^(https?:\/\/)([\w-]+(\.[\w-]+)+)(\/[\w-./?%&=]*)?$/i;
      if (!urlPattern.test(updateUrl)) {
        newErrors.linkUrl = "Si prega di digitare un URL valido nel campo URL collegamento";
      }

    }

    

    // if (!company) newErrors.company = "Azienda è obbligatorio.";

    // if (!location) newErrors.location = "Location is required.";

    // if (!experienceYears || experienceYears <= 0) newErrors.experienceYears = "Anni esperienza deve essere un numero uguale o maggiore di zero";
    //   if (!dailyRate || dailyRate <= 0) newErrors.dailyRate = "Rate giornaliero deve essere un numero uguale o maggiore di zero";


    if (typeName == "T&M") {
      console.log('required');
      console.log('typeName:', typeName);
      console.log('experienceYears:', !experienceYears);
      console.log('dailyRate:', !dailyRate);

      if (experienceYears == null || experienceYears < 0) { newErrors.experienceYears = "Anni esperienza deve essere un numero uguale o maggiore di zero" };
      // if (!dailyRate || dailyRate <= 0) { newErrors.dailyRate = "Rate giornaliero deve essere un numero uguale o maggiore di zero" };
      if (dailyRate == null || dailyRate < 0) {
        newErrors.dailyRate = "Rate giornaliero deve essere un numero uguale o maggiore di zero";
      }


    }

    
    // if (!dateStart) newErrors.dateStart = "Start Available date is required.";
    // if (!dateEnd) newErrors.dateEnd = "End Available date is required.";
    // if (!description) newErrors.description = "Description is required.";

    // Check if description is provided

    // Check if description has at least 100 characters
    // else if (description.length < 100) {
    //   newErrors.description = "Description is invalid! The minimum length should be 100 characters.";
    // }

    // if (!longTerm) newErrors.description = "longTerm is required.";
    // if (!fullRemote) newErrors.description = "fullRemote is required.";

    return Object.keys(newErrors).length === 0 ? true : newErrors;
  };


  // Function to show success or error message and hide it after a few seconds
  const showMessage = (type, message) => {
    if (type === 'success') {
      setSuccessMessage(message);
      setTimeout(() => {
        setSuccessMessage('');
      }, 3000); // Hide success message after 3 seconds
    } else if (type === 'error') {
      setErrorMessage(message);
      setTimeout(() => {
        setErrorMessage('');
      }, 3000); // Hide error message after 3 seconds
    }
  };

  // Function to get the company name by company ID
  function getCompanyNameById(companyId) {
    const company = companies.find(c => c.IdCompany === companyId);
    return company ? company.CompanyName : "Company not found";
  }

  // Handle submit
  const handleSubmit = () => {
    // Validate form before submission
    const validation = validateForm();

    if (selectItDev) {

      if (validation !== true) {
        const errorMessage = Object.values(validation)[0];
        alert(errorMessage);
        return;
      }

    }


    // Get the user ID from localStorage
    const user = JSON.parse(localStorage.getItem('user')); // Assuming user data is stored in localStorage
    if (!user || !user.user.IdUser) {
      alert('User not authenticated. Please log in.');
      return;
    }

    // if(linkUrl){
    //   var urlPattern = /^(https?:\/\/)([\w-]+(\.[\w-]+)+)(\/[\w-./?%&=]*)?$/i;
    //   if(!urlPattern.test(linkUrl)){
    //     alert("Si prega di digitare un URL valido nel campo URL collegamento");
    //     return;
    //   }
    // }

    let updateUrl = linkUrl;

    // Agar https:// ya http:// nahi diya gaya ho, toh https:// add karo
    if (linkUrl && !/^https?:\/\//i.test(updateUrl)) {
      updateUrl = 'https://' + linkUrl;
    }
  
    // Ab validate karo
    if (updateUrl) {
      var urlPattern = /^(https?:\/\/)([\w-]+(\.[\w-]+)+)(\/[\w\-./?%&=]*)?$/i;
      if (!urlPattern.test(updateUrl)) {
        alert("Si prega di digitare un URL valido nel campo URL collegamento");
        return;
      }
    }

    const userId = user.user.IdUser;
    const userEmail = user.user.email;

    // console.log(userEmail);

    // console.log(user);
    // Here you can make an API call or do whatever you'd like

    setIsSubmitting(true);
    setErrorMessage('');
    setSuccessMessage('');

    setFormLoading(true);  // Show loader during form submission


    // Create FormData
    const formdata = new FormData();
    formdata.append("Title", title);
    formdata.append("Description", description);
    formdata.append("ItDev", selectItDev);
    formdata.append('attachment', attachment);
    formdata.append('attachment_name', attachmentName);

    if (IsAdminPlatform) {
      // formdata.append("IdCompany", 4);
      formdata.append("IdCompany", user.user.IdCompany);
    } else {
      formdata.append("IdCompany", user.user.IdCompany);
    }
    // formdata.append("IdCompany", company);
    formdata.append("IdCategoryRequest", category);
    formdata.append("IdTypeRequest", type);
    formdata.append("Location", location);
    formdata.append("FullRemote", fullRemote ? "1" : "0");
    formdata.append("ExperienceYears", experienceYears);
    formdata.append("DailyRate", dailyRate);
    formdata.append("DateStartAvailable", dateStart ? dateStart.format('YYYY-MM-DD') : '');
    formdata.append("DateEndAvailable", dateEnd ? dateEnd.format('YYYY-MM-DD') : '');
    formdata.append("LongTerm", longTerm ? "1" : "0");
    // formdata.append("PublishDate", publishDate ? publishDate.format('YYYY-MM-DD') : '');
    formdata.append("PublishDate", dayjs().format('YYYY-MM-DD'));
    formdata.append("CreationUser", userId);  // Add the user ID to the form data
    // if(!['', null, 'null'].includes(linkUrl)){
    //   formdata.append("LinkUrl", linkUrl);
    //   formdata.append("LinkDescription", linkDescription);
  
    // }

    if(!['', null, 'null'].includes(updateUrl)){
      formdata.append("LinkUrl", updateUrl);
      formdata.append("LinkDescription", linkDescription);
  
    }

    formdata.append("is_email_enabled", isEmailEnabled);

    const requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
    };

    fetch(`${url}auth/create-requests`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setIsSubmitting(false);
        if (result.message === "Request created successfully.") {
          // setSuccessMessage('Request created successfully!');
          showMessage('success', 'Request created successfully!')

          // mail sent for switch button
          getEmailNotificationStatus().then((data) => {
            console.log('data:', data);

            if (data.email_notification_enabled) {
              sendEmail(result.data.IdRequest);
            }

          });

          

          if (!IsAdminPlatform) {

            let requestData = [];


            if (selectItDev) {
              // Send email with request details
              requestData = [
                {
                  IdRequest: result.data.IdRequest,  // Assuming the request ID is returned in the response
                  Title: title,
                  Description: description,
                  // CompanyName: companyName,  // Assuming CompanyName is part of the user data
                  companyName: getCompanyNameById(user.user.IdCompany),
                  CategoryName: categoryName,
                  TypeName: typeName,
                  Location: location,
                  FullRemote: fullRemote,
                  ExperienceYears: experienceYears,
                  DailyRate: dailyRate,
                  DateStartAvailable: dateStart ? dateStart.format('DD-MM-YYYY') : '',
                  DateEndAvailable: dateEnd ? dateEnd.format('DD-MM-YYYY') : '',
                  LongTerm: longTerm,
                  PublishDate: dayjs().format('DD-MM-YYYY'),
                }
              ];

            } else {
              // Send email with request details
              requestData = [
                {
                  IdRequest: result.data.IdRequest,  // Assuming the request ID is returned in the response
                  Title: title,
                  Description: description,
                  CompanyName: getCompanyNameById(user.user.IdCompany),  // Assuming CompanyName is part of the user data
                  CategoryName: categoryName,
                  TypeName: typeName,
                  PublishDate: dayjs().format('DD-MM-YYYY'),

                 

                }
              ];

            }


            // const email = 'rizwaneng6@gmail.com';  // Assuming user's email is stored in the user object
            const email = userEmail;  // Assuming user's email is stored in the user object
            const subject = "User Request Details";

            // Call sendUserRequestEmail function to send email after successful request creation
            // sendUserRequestEmail(requestData, email, subject)
            //   .then((emailResult) => {
            //     console.log("Email sent successfully:", emailResult);
            //   })
            //   .catch((emailError) => {
            //     console.error("Error sending email:", emailError);
            //     setErrorMessage("Failed to send email.");
            //   });


            sendMessage(result.data.IdRequest, requestData, subject, userId);


          }


          // Reset the form to initial state
          setType('');
          setCategory('');
          setCompany('');
          setLocation('');
          setExperienceYears('');
          setDailyRate('');
          setFullRemote(false);
          setLongTerm(false);
          setDateStart(null);
          setDateEnd(null);
          setPublishDate(null);
          setTitle('');
          setDescription('');

          setlinkUrl('');
          setlinkDescription('');

          setAttachment(null);

          // window.location.href = '/dashboard/request-list';
          getRequests();
          setSelectedTab(0);

        } else if (result.error && result.messages) {
          // Check for validation errors
          var akerrorMessage = '';
          // let errorMessage = 'Please fix the following errors:\n';
          Object.entries(result.messages).forEach(([field, messages]) => {
            console.log("messages", messages);
            messages.forEach((msg) => {
              akerrorMessage += `${msg}\n`;
            });
          });                           
          alert(akerrorMessage);  // Show the validation error messages in an alert
        } else {
          // setErrorMessage('Failed to create request. Please try again.');
          showMessage('error', 'Failed to create request. Please try again.');
        }
      })
      .catch((error) => {
        setIsSubmitting(false);
        // setErrorMessage('Ops, errore in fase di creazione richiesta.');

        // setErrorMessage('An error occurred while creating the request.');
        console.error(error);
      })
      .finally(() => {
        setFormLoading(false);  // Hide loader after form submission
      });


  }


  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  // FullRemoteLabel Component with concise text and improved styling
  const FullRemoteLabel = ({ fullRemote }) => {
    let label;
    let labelStyle;

    switch (fullRemote) {
      case 1:
        label = "Remote";  // Short, professional text
        labelStyle = { color: '#28a745', fontWeight: 'bold' };  // Green for remote
        break;
      case 0:
        label = "On-site";  // Short, professional text
        labelStyle = { color: '#dc3545', fontWeight: 'bold' };  // Red for on-site
        break;
      default:
        label = "";  // Fallback text
        labelStyle = { color: '#6c757d', fontWeight: 'normal' };  // Gray for unknown status
    }

    return <span style={labelStyle}>{label}</span>;
  };

  // LongTermLabel Component to display Long-Term or Short-Term
  const LongTermLabel = ({ longTerm }) => {
    let label = '';
    let labelStyle = { color: '#6c757d' }; // Default style for Unknown

    switch (longTerm) {
      case 1:
        label = 'Long-Term';
        labelStyle = { color: '#28a745', fontWeight: 'bold' }; // Green for Long-Term
        break;
      case 0:
        label = 'Short-Term';
        labelStyle = { color: '#dc3545', fontWeight: 'bold' }; // Red for Short-Term
        break;
      default:
        label = ''; // Fallback for any other value
        labelStyle = { color: '#6c757d', fontWeight: 'normal' }; // Gray for Unknown status
    }

    return <span style={labelStyle}>{label}</span>;
  };

  // Function to handle truncation of description
  const truncatedDescription = (text, limit) => {
    if (text.length > limit) {
      return `${text.substring(0, limit)}...`;
    }
    return text;
  };

  const columns = [
    { Header: "#", accessor: "IdRequest" },
    { Header: "Titolo", accessor: "Title" },
    // { Header: "Descrizione", accessor: "Description" },
    // { Header: "Azienda", accessor: "CompanyName" },
    ...(IsAdminPlatform == 1 ? [{ Header: "Azienda", accessor: "CompanyName" }] : []),
    { Header: "Categoria", accessor: "CategoryName" },
    { Header: "Tipologia", accessor: "TypeName" },
    // { Header: "Luogo", accessor: "Location" },
    { Header: "Full Remote", accessor: "FullRemote" },
    // { Header: "Esperienza (Anni)", accessor: "ExperienceYears" },
    { Header: "Rate giornaliero", accessor: "DailyRate" },
    { Header: "Data inizio prevista", accessor: "DateStartAvailable" },
    { Header: "Data Fine prevista", accessor: "DateEndAvailable" },
    // { Header: "Lungo periodo", accessor: "LongTerm" },
    { Header: "Allegato", accessor: "attachment" },

    { Header: "Collegamento URL", accessor: "LinkUrl" },

    { Header: "Data pubblicazione", accessor: "PublishDate" },
    // { Header: "Actions", accessor: "actions" },

    // Conditionally include Actions column based on IsAdminPlatform
    ...(IsAdminPlatform == 1 ? [
      { Header: "Actions", accessor: "actions" }
    ] : []),

  ];

  const getTitleStyle = () => {
    return window.innerWidth < 425
      ? { whiteSpace: 'normal', wordWrap: 'break-word' }  // Allow wrapping on small screens
      : { maxWidth: '200px', wordWrap: 'break-word', whiteSpace: 'normal' };  // Truncate on large screens
  };

  const getDescriptionStyle = () => {
    return window.innerWidth < 425
      ? { wordWrap: 'break-word', whiteSpace: 'normal' }  // Allow wrapping on small screens
      : { maxWidth: '300px', wordWrap: 'break-word', whiteSpace: 'normal' };  // Truncate on large screens
  };

  const rows = requests.map((request, index) => ({
    IdRequest: request.IdRequest,
    // alert('ldldldl');
    // IdRequest: index + 1,
    // Add a raw title field for searching
    rawTitle: request.Title,
    Title: <Link onClick={() => { navigate(`/Richieste-Dettagli?requestId=${btoa(request.IdRequest)}&back=requests`); }} sx={{ cursor: 'pointer' }}>{truncatedDescription(request.Title, 50)}</Link>,
    Description: truncatedDescription(request.Description, 50),
    // Title with dynamic inline styling
    // Title: (
    //   <div style={getTitleStyle()}  // Apply dynamic title style
    //    >
    //   <Link
    //     onClick={() => { navigate(`/requests-details?requestId=${request.IdRequest}`); }}
    //     sx={{ cursor: 'pointer' }}

    //   >
    //     {request.Title}
    //   </Link>
    //   </div>
    // ),

    // Description with dynamic inline styling
    // Description: (
    //   <div style={getDescriptionStyle()}>  {/* Apply dynamic description style */}
    //     {request.Description}
    //   </div>
    // ),
    ...(IsAdminPlatform == 1 && { CompanyName: request.CompanyName }),
    CategoryName: request.CategoryName,
    TypeName: request.TypeName,
    Location: request.Location,
    // Location: 'ldlldlld',
    FullRemote: <FullRemoteLabel fullRemote={request.FullRemote} />,
    ExperienceYears: request.ExperienceYears,
    DailyRate: request.DailyRate,
    DateStartAvailable: request.DateStartAvailable ? dayjs(request.DateStartAvailable).format('DD-MM-YYYY') : '',
    DateEndAvailable: request.DateEndAvailable ? dayjs(request.DateEndAvailable).format('DD-MM-YYYY') : '',
    LongTerm: <LongTermLabel longTerm={request.LongTerm} />,
    // attachment: request.attachment ?? null,
    attachment: (request.attachment) ? (<Link 
    onClick={() => window.open(`${fileUploadUrl}/${request.attachment ?? null}`, '_blank')} 
    sx={{ cursor: 'pointer' }}
  >
    {/* {request.attachment == null ? '' : request.attachment.split('/')[1]} */}
    <AttachFileIcon fontSize={"20"} sx={{color: '#006bd6', display: 'flex', justifyContent: 'center', alignItems: 'center'}} />
  </Link>) : null,

    LinkUrl: (request.LinkUrl) ? (<Link 
      onClick={() => window.open(`${request.LinkUrl ?? null}`, '_blank')} 
      sx={{ cursor: 'pointer' }}
    >
      <LinkIcon fontSize={"20"} sx={{color: '#006bd6', display: 'flex', justifyContent: 'center', alignItems: 'center'}} />
    </Link>) : null,

    PublishDate: dayjs(request.PublishDate).format('DD-MM-YYYY'),
    actions: (IsAdminPlatform) ? ( //request.CreationUser == user.IdUser || 
      <Box sx={{ display: 'flex', gap: 1 }}>
        {
          (!request.EmailSent) ? (
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => { sendEmail(request.IdRequest, true); } }
              sx={{
                fontWeight: 'bold',
                padding: '8px 16px',
                color: '#fff',
                backgroundColor: 'green',
                '&:hover': { backgroundColor: 'green' },
              }}
            >
              Invia email
            </Button>
          ) : null
        }
        
        {/* Edit Button */}
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => handleEditDialogOpen(request)}
          sx={{
            fontWeight: 'bold',
            padding: '8px 16px',
            color: '#fff',
            // backgroundColor: '#1976d2',
            backgroundColor: '#183759',
            '&:hover': { 
              // backgroundColor: '#1565c0',
              backgroundColor: '#204b80',
             },
          }}
        >
          {/* Edit */}
          Modifica
        </Button>

        {/* Delete Button */}
        <Button
          variant="contained"
          color="error"
          size="small"
          onClick={() => handleDeleteDialogOpen(request.IdRequest)}
          sx={{
            fontWeight: 'bold',
            padding: '8px 16px',
            backgroundColor: '#d32f2f',
            color: '#fff',
            '&:hover': { backgroundColor: '#c62828' },
          }}
        >
          {/* Delete */}
          Cancella
        </Button>
      </Box>
    ) : null,
  }));

  const handleEditDialogOpen = (request) => {
    console.log("edit-request", request);
    // Set the form fields based on the selected request's data
    setRequestName(request.Title); // Set request name/title
    setEditRequestId(request.IdRequest); // Set the request ID (for submitting the edit)
    setTitle(request.Title); // Set title (if needed in the form)
    setCompany(request.IdCompany); // Set company, assuming request has a `CompanyId` field
    setCategory(request.IdCategoryRequest); // Set category, assuming request has a `CategoryId` field
    setType(request.IdTypeRequest); // Set request type, assuming request has a `TypeId` field
    setLocation(request.Location); // Set location, assuming request has a `Location` field
    setExperienceYears(request.ExperienceYears); // Set experience years
    setDailyRate(request.DailyRate); // Set daily rate
    setFullRemote(request.FullRemote); // Set full remote flag
    setLongTerm(request.LongTerm); // Set long term flag
    setDateStart(request.DateStartAvailable); // Set start available date
    setDateEnd(request.DateEndAvailable); // Set end available date
    setPublishDate(request.PublishDate); // Set publish date
    setDescription(request.Description); // Set description
    setlinkUrl(request.LinkUrl);
    setlinkDescription(request.LinkDescription);
    

    // setSelectItDev(request.ItDev);
    setSelectItDev(requestTypes.find( x => x.IdRequestType == request.IdTypeRequest).ItDev);

    setoldAttachment(request.attachment);
    // setAttachment(request.attachment);

    // Open the dialog
    setOpenEditDialog(true);
  };

  const handleEditDialogClose = () => {
    // Reset all the form fields to their default or empty state
    setRequestName(""); // Reset request name
    setEditRequestId(null); // Reset the request ID
    setTitle(""); // Reset title
    setCompany(""); // Reset company (assuming it's an ID or null if not selected)
    setCategory(""); // Reset category (similar assumption as company)
    setType(""); // Reset request type
    setLocation(""); // Reset location
    setExperienceYears(""); // Reset experience years
    setDailyRate(""); // Reset daily rate
    setFullRemote(false); // Reset full remote checkbox
    setLongTerm(false); // Reset long term checkbox
    setDateStart(null); // Reset start available date
    setDateEnd(null); // Reset end available date
    setPublishDate(null); // Reset publish date
    setDescription(""); // Reset description
    setSelectItDev(true);
    setoldAttachment(null);

    // Reset the file input when the modal closes
    if (inputFile.current) {
      inputFile.current.value = "";
    }
    setAttachment(null); // Clear the attachment state

    // Close the dialog
    setOpenEditDialog(false);
  };


  const handleEditSubmit = () => {
  
    if (validateForm()) {
      // Create a new FormData object and append all the form fields

      let updateUrl = linkUrl;

      // Agar https:// ya http:// nahi diya gaya ho, toh https:// add karo
      if (linkUrl && !/^https?:\/\//i.test(linkUrl)) {
        updateUrl = 'https://' + linkUrl;
      }

      // Ab validate karo
      if (updateUrl) {
        var urlPattern = /^(https?:\/\/)([\w-]+(\.[\w-]+)+)(\/[\w\-./?%&=]*)?$/i;
        if (!urlPattern.test(updateUrl)) {
          alert("Si prega di digitare un URL valido nel campo URL collegamento");
          return;
        }
      }

      // Convert DateStartAvailable and DateEndAvailable to a consistent format
      const formattedStartDate = dayjs(dateStart).format("YYYY-MM-DD HH:mm:ss");
      const formattedEndDate = dayjs(dateEnd).format("YYYY-MM-DD HH:mm:ss");
      const formattedPublishDate = dayjs(publishDate).format("YYYY-MM-DD HH:mm:ss");

      const formData = new FormData();
      formData.append("Title", requestName);
      formData.append("ItDev", selectItDev);
      formData.append("Description", description); // Assuming description is a state variable

      // if(!['', null, 'null'].includes(linkUrl)){
      //   formData.append("LinkUrl", linkUrl);
      //   formData.append("LinkDescription", linkDescription);
      // }

      if (!['', null, 'null'].includes(updateUrl)) {
        formData.append("LinkUrl", updateUrl);
        formData.append("LinkDescription", linkDescription);

      }

      formData.append("IdCompany", company); // Assuming company is a state variable (company ID)
      formData.append("IdCategoryRequest", category); // Assuming category is a state variable (category ID)
      formData.append("IdTypeRequest", type); // Assuming type is a state variable (type ID)
      formData.append("Location", location); // Assuming location is a state variable
      formData.append("FullRemote", fullRemote ? "1" : "0"); // Assuming fullRemote is a boolean
      formData.append("ExperienceYears", experienceYears); // Assuming experienceYears is a state variable
      formData.append("DailyRate", dailyRate); // Assuming dailyRate is a state variable
      formData.append("DateStartAvailable", formattedStartDate); // Assuming dateStart is a state variable
      formData.append("DateEndAvailable", formattedEndDate); // Assuming dateEnd is a state variable
      formData.append("LongTerm", longTerm ? "1" : "0"); // Assuming longTerm is a boolean
      formData.append("PublishDate", formattedPublishDate); // Assuming publishDate is a state variable
      formData.append('attachment', attachment);
      formData.append('attachment_name', attachmentName);
      formData.append('oldattachment', oldattachment);

      // Define request options with the FormData as the body and POST method
      const requestOptions = {
        method: "POST",
        body: formData,
        redirect: "follow"
      };

      // Make the API request to update the request data
      fetch(`${url}auth/update-requests/${editRequestId}`, requestOptions)
        .then((response) => response.json()) // Assuming JSON response
        .then((result) => {

          if (result.error && result.messages) {
            // Check for validation errors
            var akerrorMessage = '';
            // let errorMessage = 'Please fix the following errors:\n';
            Object.entries(result.messages).forEach(([field, messages]) => {
              console.log("messages", messages);
              messages.forEach((msg) => {
                akerrorMessage += `- ${msg}\n`;
              });
            });                           
            alert(akerrorMessage);  // Show the validation error messages in an alert
            return;
          }          

          // If the update is successful, update the state with the new request data
          // setRequests(requests.map((request) =>
          //   request.IdRequest === editRequestId
          //     ? {
          //         ...request,
          //         Title: requestName,
          //         Description: description,
          //         IdCompany: company, // Assuming company is a state variable (company ID)
          //         IdCategoryRequest: category, // Assuming category is a state variable (category ID)
          //         IdTypeRequest: type, // Assuming type is a state variable (type ID)
          //         Location: location, // Assuming location is a state variable
          //         FullRemote: fullRemote , // Assuming fullRemote is a boolean
          //         ExperienceYears: experienceYears, // Assuming experienceYears is a state variable
          //         DailyRate: dailyRate, // Assuming dailyRate is a state variable
          //         DateStartAvailable: dayjs(dateStart).format('DD-MM-YYYY'), // Assuming dateStart is a state variable
          //         DateEndAvailable: dayjs(dateEnd).format('DD-MM-YYYY'), // Assuming dateEnd is a state variable
          //         LongTerm: longTerm, // Ensure correct value is set
          //         PublishDate: dayjs(publishDate).format('DD-MM-YYYY') // Assuming publishDate is a state variable
          //       }
          //     : request
          // ));

          getRequests();

          // window.location.reload();
          // Close the dialog after the update
          handleEditDialogClose();
        })
        .catch((error) => console.error("Error updating request:", error));

    }

  };


  const handleDeleteDialogOpen = (requestId) => {
    setDeleteRequestId(requestId);
    setOpenDeleteDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setDeleteRequestId(null);
    setOpenDeleteDialog(false);
  };

  const handleDeleteConfirm = () => {
    const requestOptions = {
      method: "DELETE",
      redirect: "follow",
    };

    // Construct the URL dynamically using deleteRequestId
    fetch(`${url}auth/requests/${deleteRequestId}`, requestOptions)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to delete request: ${response.statusText}`);
        }
        return response.json(); // Parse JSON response from the server
      })
      .then((result) => {
        console.log(result);  // This will log: { "message": "Request deleted successfully." }

        // If the message indicates success, update the state
        if (result.message === "Request deleted successfully.") {
          // Update the state to remove the deleted request
          setRequests(requests.filter((request) => request.IdRequest !== deleteRequestId));

          // Close the delete confirmation dialog
          setOpenDeleteDialog(false);

          // Optionally, you can show a success notification here
        } else {
          // Handle unexpected response or error message
          console.error("Unexpected response:", result);
        }
      })
      .catch((error) => {
        console.error("Error deleting request:", error);
        // Optionally, display a user-friendly error message here
      });
  };


  const sendEmail = (id, refresh = false) => {
    var akLoginUser = JSON.parse(localStorage.getItem('user'));
    //alert(akLoginUser.user.email);
    setLoading(true);
    var formData = new FormData();
    formData.append('cc_email', akLoginUser.user.email);
    formData.append("is_email_enabled", isEmailEnabled);
    formData.append('is_create_request', 1);
    fetch(`${url}auth/send-request-email/${id}`, {
      method: 'POST',
      body: formData
    }).then(res => {
      return res.json();
    }).then(json => {
      
        setLoading(false);
        if(typeof json.message != 'undefined'){
          alert(json.message);
        }
        if(refresh){
          window.location.reload();
        }
    })
  }


  const sendMessage = (IdRequest, ObjectMessage, Message, CreationUser) => {
    const formdata = new FormData();
    formdata.append("IdRequest", IdRequest);
    formdata.append("ObjectMessage", JSON.stringify(ObjectMessage));
    formdata.append("Message", Message);
    formdata.append("CreationUser", CreationUser);

    const requestOptions = {
      method: "POST",
      body: formdata,

    };

    fetch(`${url}auth/create-messages`, requestOptions)
      .then((response) => response.json())
      .then((result) => console.log(result))
      .catch((error) => console.error("Error:", error));
  }

  const getEmailNotificationStatus = async () => {
    try {
      const response = await fetch(`${url}auth/settings/email-notification`);
      
      if (!response.ok) {
        throw new Error('Failed to fetch email notification status');
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching email notification status:', error);
      return null;
    }
  };
  
  const getEmailNotificationStatus1 = () => {


    fetch(`${url}auth/settings/email-notification`)
      .then(response => response.json())
      .then(data => {
        console.log('EmailNotificationStatus :', data);
        setIsEmailEnabled(data.email_notification_enabled);

      });

  };


  // // Example usage of the function
  // sendMessage("76", "object message", "helo this content 123", "1");


  // Function to send user request email
  async function sendUserRequestEmail(data, email, subject) {
    // Create a new FormData object
    const formdata = new FormData();

    // Loop through the data array and append each item to FormData
    data.forEach((requestData, index) => {
      formdata.append(`data[${index}][IdRequest]`, requestData.IdRequest);
      formdata.append(`data[${index}][Title]`, requestData.Title);
      formdata.append(`data[${index}][Description]`, requestData.Description);
      formdata.append(`data[${index}][CompanyName]`, requestData.CompanyName);
      formdata.append(`data[${index}][CategoryName]`, requestData.CategoryName);
      formdata.append(`data[${index}][TypeName]`, requestData.TypeName);
      formdata.append(`data[${index}][Location]`, requestData.Location);
      formdata.append(`data[${index}][FullRemote]`, requestData.FullRemote);
      formdata.append(`data[${index}][ExperienceYears]`, requestData.ExperienceYears);
      formdata.append(`data[${index}][DailyRate]`, requestData.DailyRate);
      formdata.append(`data[${index}][DateStartAvailable]`, requestData.DateStartAvailable);
      formdata.append(`data[${index}][DateEndAvailable]`, requestData.DateEndAvailable);
      formdata.append(`data[${index}][LongTerm]`, requestData.LongTerm);
      formdata.append(`data[${index}][PublishDate]`, requestData.PublishDate);
    });

    // Append email and subject fields
    formdata.append("email", email);
    formdata.append("subject", subject);

    const requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
      headers: {
        // Optional: Authorization header if required
        // 'Authorization': 'Bearer your-token-here'
      }
    };

    // Send the request using fetch
    return fetch(`${url}auth/send-user-request-email`, requestOptions)
      .then((response) => response.json())  // Expecting a JSON response
      .then((result) => {
        console.log(result);  // Log the result from the server
        return result;  // Return the result for further handling if needed
      })
      .catch((error) => {
        console.error('Error:', error);  // Handle any errors
        throw error;  // Rethrow the error to handle it outside the function if needed
      });
  }

  // Call the function to send the email

  // sendUserRequestEmail(requestData, email, subject)
  // .then((result) => {
  //   // Handle successful email sending here
  //   console.log("Email sent successfully:", result);
  // })
  // .catch((error) => {
  //   // Handle error
  //   console.error("Error sending email:", error);
  // });



  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* Loader Component */}
      <Backdrop open={loading || formLoading} sx={{ color: '#fff', zIndex: 1000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                // bgColor="info"  
                bgColor="#183759"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {/* Requests */}
                  Richieste
                </MDTypography>
              </MDBox>

              <Box sx={{ width: '100%' }}>
                <Tabs
                  value={selectedTab}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="fullWidth"
                  aria-label="basic tabs example"
                >
                  {/* <Tab label="List Requests" />
                  <Tab label="Add Request" /> */}

                  <Tab label="Elenco Richieste" />
                  { !!IsAdminPlatform && 
                    <Tab label="Nuova Richiesta" />
                  }
                  

                </Tabs>

                {selectedTab === 0 && (
                  <MDBox pt={3}>

                    {IsAdminPlatform === 1 && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={exportToExcel}
                        sx={{
                          color: '#fff',
                          marginTop: '5px',
                          marginLeft: '20px',
                          padding: '10px 20px',
                          fontSize: '14px',
                          fontWeight: 'bold',
                          textTransform: 'none',
                          borderRadius: '8px',
                          // backgroundColor: '#1976d2',
                          backgroundColor: '#183759',
                          '&:hover': {
                            // backgroundColor: '#1565c0',
                            backgroundColor: '#204b80',
                          },
                          '@media (max-width: 600px)': {
                            fontSize: '12px',
                            padding: '8px 16px',
                          },
                        }}
                      >
                        {/* Export to Excel */}
                        Estrai in Excel
                      </Button>
                    )}

                    <DataTable
                      table={{ columns, rows }}
                      isSorted={false}
                      entriesPerPage={false}
                      // entriesPerPage={{defaultValue:10}}
                      showTotalEntries={false}
                      noEndBorder
                      canSearch
                      currentPageIndex={currentPageIndex}
                      setCurrentPageIndex={setCurrentPageIndex}
                    />

                  </MDBox>
                )}

                {selectedTab === 1 && (
                  <MDBox px={4} mx={2} mt={2}>
                    <MDTypography variant="h6" mb={3} align="center">
                      {/* Add New Request */}
                      Nuova Richiesta
                    </MDTypography>

                    <Grid container spacing={3} justifyContent="center" alignItems="flex-start">
                      {/* <Grid item xs={12}>
                        <MDBox mb={1}>
                          <Grid
                            container
                            spacing={2}
                            sx={{
                              backgroundColor: 'lightgray',
                              padding: 2,
                              borderRadius: 1,
                              '& .MuiGrid-item': {
                                paddingLeft: '2px',
                                paddingTop: '2px',
                              },
                            }}
                          >
                            <Grid item xs={12} md={6} lg={4}>
                              <MDTypography variant="h4" fontWeight="regular" color="text">
                                New Request
                              </MDTypography>
                            </Grid>
                          </Grid>
                        </MDBox>
                      </Grid> */}

                      <Grid container spacing={3} justifyContent="center">

                        {/* <Grid item xs={12} sm={6} md={4}>
                          <MDBox mt={3}>
                            <FormControl fullWidth>
                              <TextField
                                label="Title"
                                variant="outlined"
                                value={title}
                                onChange={handleChange(setTitle)}
                              />
                            </FormControl>
                          </MDBox>
                        </Grid> */}


                        <Grid item xs={12} sm={6} md={4}>
                          <MDBox mt={3}>
                            <FormControl fullWidth>
                              {/* <InputLabel id="type-select-label">Request Type</InputLabel> */}
                              <InputLabel id="type-select-label">Tipologia</InputLabel>
                              {/* <Select
                                            labelId="type-select-label"
                                            id="type-select"
                                            value={type}
                                            label="Request Type"
                                            onChange={handleTypeChange}
                                            style={{ height: 45 }}
                                        >
                                            <MenuItem value={21}>Type 1</MenuItem>
                                            <MenuItem value={22}>Type 2</MenuItem>
                                            <MenuItem value={23}>Type 3</MenuItem>
                                        </Select> */}

                              <Select
                                labelId="type-select-label"
                                id="type-select"
                                value={type}
                                label="Request Type"
                                onChange={handleTypeChange}
                                style={{ height: 45 }}
                                sx={{
                                  '& .MuiSelect-icon': {
                                    display: 'block !important',  // Force icon to be visible
                                    fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                                  },
                                }}
                                IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed
                              >
                                {isLoading ? (
                                  <MenuItem disabled>
                                    <CircularProgress size={24} sx={{ mr: 1 }} />
                                    Loading...
                                  </MenuItem>
                                ) : requestTypes.length > 0 ? (
                                  requestTypes.map((type) => (
                                    <MenuItem key={type.IdRequestType} value={type.IdRequestType}>
                                      {type.RequestType}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem disabled>No request types available</MenuItem>
                                )}
                              </Select>

                            </FormControl>
                          </MDBox>
                        </Grid>

                        {/* <Grid item xs={12} sm={6} md={4}>
                          <MDBox mt={3}>
                            <FormControl fullWidth>
                              <InputLabel id="type-select-label1">It Dev</InputLabel>
                             
                              <Select
                                labelId="type-select-label1"
                                id="type-select"
                                value={selectItDev ? 1 : 2}
                                label="It Dev"
                                onChange={handleItDevChange}
                                style={{ height: 45 }}
                                sx={{
                                  '& .MuiSelect-icon': {
                                    display: 'block !important',  // Force icon to be visible
                                    fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                                  },
                                }}
                                IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed
                              >
                                {isLoading ? (
                                  <MenuItem disabled>
                                    <CircularProgress size={24} sx={{ mr: 1 }} />
                                    Loading...
                                  </MenuItem>
                                ) : itDev.length > 0 ? (
                                  itDev.map((type) => (
                                    <MenuItem key={type.id} value={type.id}>
                                      {type.name}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem disabled>No it Dev available</MenuItem>
                                )}
                              </Select>

                            </FormControl>
                          </MDBox>
                        </Grid> */}

                        {/* <Grid item xs={12} sm={6} md={4}>
                          <MDBox mt={3}>
                            <FormControl fullWidth>
                              <InputLabel id="company-select-label">Company</InputLabel>
                              <Select
                                            labelId="company-select-label"
                                            id="company-select"
                                            value={company}
                                            label="Company"
                                            onChange={handleCompanyChange}
                                            style={{ height: 45 }}
                                        >
                                            <MenuItem value={22}>Company 1</MenuItem>
                                            <MenuItem value={23}>Company 2</MenuItem>
                                            <MenuItem value={24}>Company 3</MenuItem>
                                        </Select>

                              <Select
                                labelId="company-select-label"
                                id="company-select"
                                value={ IsAdminPlatform ? company : user.IdCompany}
                                disabled={IsAdminPlatform ? false : true}
                                label="Company"
                                onChange={handleCompanyChange}
                                style={{ height: 45 }}
                                sx={{
                                  '& .MuiSelect-icon': {
                                    display: 'block !important',  // Force icon to be visible
                                    fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                                  },
                                }}
                                IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed
                              >
                                {isLoading ? (
                                  <MenuItem disabled>
                                    <CircularProgress size={24} sx={{ mr: 1 }} />
                                    Loading...
                                  </MenuItem>
                                ) : companies.length > 0 ? (
                                  companies.map((comp) => (
                                    <MenuItem key={comp.IdCompany} value={comp.IdCompany}>
                                      {comp.CompanyName}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem disabled>No companies available</MenuItem>
                                )}
                              </Select>

                            </FormControl>
                          </MDBox>
                        </Grid> */}

                        <Grid item xs={12} sm={6} md={4}>
                          <MDBox mt={mtValue3}>
                            <FormControl fullWidth>
                              {/* <InputLabel id="category-select-label">Category</InputLabel> */}
                              <InputLabel 
                                id="category-select-label"
                                // sx={{
                                //   '&.Mui-focused': {
                                //     color: 'inherit !important', // Prevent blue focus color
                                //   },
                                // }}
                              >
                                Categoria
                              </InputLabel>
                              {/* <Select
                                            labelId="category-select-label"
                                            id="category-select"
                                            value={category}
                                            label="Category"
                                            onChange={handleCategoryChange}
                                            style={{ height: 45 }}
                                        >
                                            <MenuItem value={43}>Category 1</MenuItem>
                                            <MenuItem value={44}>Category 2</MenuItem>
                                            <MenuItem value={45}>Category 3</MenuItem>
                                        </Select> */}

                              <Select
                                labelId="category-select-label"
                                id="category-select"
                                value={category}
                                label="Category"
                                onChange={handleCategoryChange}
                                style={{ height: 45 }}
                                sx={{
                                  '& .MuiSelect-icon': {
                                    display: 'block !important',  // Force icon to be visible
                                    fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                                  },
                                }}

                                // sx={{
                                //   '& .MuiSelect-icon': {
                                //     display: 'block !important',  // Force icon to be visible
                                //     fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                                //   },
                                //   '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                //     borderColor: '#c4c4c4 !important', // Keep gray border on focus
                                //   },
                                //   '& .MuiOutlinedInput-root.Mui-focused': {
                                //     boxShadow: 'none !important',       // Remove focus glow
                                //   },
                                //   '& .MuiInputLabel-root.Mui-focused': {
                                //     color: 'inherit !important',        // Prevent label turning blue
                                //   },
                                // }}
                                
                                IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed
                              >
                                {isLoading ? (
                                  <MenuItem disabled>
                                    <CircularProgress size={24} sx={{ mr: 1 }} />
                                    Loading...
                                  </MenuItem>
                                ) : categories.length > 0 ? (
                                  categories.filter(cat => cat.show_in_filter != 0 ).map((cat) => (
                                    <MenuItem key={cat.IdRequestCategory} value={cat.IdRequestCategory}>
                                      {cat.RequestCategory}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem disabled>No categories available</MenuItem>
                                )}
                              </Select>

                            </FormControl>
                          </MDBox>
                        </Grid>



                        {/* <Grid item xs={12} sm={6} md={4}>
                          <MDBox mt={3}>
                            <FormControl fullWidth>
                              <InputLabel id="type-select-label1">It Dev</InputLabel>
                             
                              <Select
                                labelId="type-select-label1"
                                id="type-select"
                                value={selectItDev ? 1 : 2}
                                label="It Dev"
                                onChange={handleItDevChange}
                                style={{ height: 45 }}
                                sx={{
                                  '& .MuiSelect-icon': {
                                    display: 'block !important',  // Force icon to be visible
                                    fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                                  },
                                }}
                                IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed
                              >
                                {isLoading ? (
                                  <MenuItem disabled>
                                    <CircularProgress size={24} sx={{ mr: 1 }} />
                                    Loading...
                                  </MenuItem>
                                ) : itDev.length > 0 ? (
                                  itDev.map((type) => (
                                    <MenuItem key={type.id} value={type.id}>
                                      {type.name}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem disabled>No it Dev available</MenuItem>
                                )}
                              </Select>

                            </FormControl>
                          </MDBox>
                        </Grid> */}

                        <Grid item xs={12} sm={6} md={4}>
                          <MDBox mt={mtValue3}>
                            <FormControl fullWidth>
                              <TextField
                                // label="Title"
                                label="Titolo"
                                variant="outlined"
                                value={title}
                                onChange={handleChange(setTitle)}
                                // sx={{
                                //   // Keep default border even when focused
                                //   '& .MuiOutlinedInput-root': {
                                //     '& fieldset': {
                                //       borderColor: '#c4c4c4', // Default MUI border color (gray)
                                //     },
                                //     '&:hover fieldset': {
                                //       borderColor: '#c4c4c4', // Optional: darker gray on hover
                                //     },
                                //     '&.Mui-focused fieldset': {
                                //       borderColor: '#c4c4c4', // Keep it same on focus (no blue)
                                //     },
                                //     '&.Mui-focused': {
                                //       boxShadow: 'none', // Remove any glow
                                //     },
                                //   },
                                //   // Prevent label color change
                                //   '& .MuiInputLabel-root.Mui-focused': {
                                //     color: 'inherit',
                                //   },
                                // }}
                              />
                            </FormControl>
                          </MDBox>
                        </Grid>


                        {selectItDev ? (

                          <>

                            <Grid item xs={12} sm={6} md={4}>
                              <MDBox mt={mtValue2}>
                                <FormControl fullWidth>
                                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                    <DemoContainer components={['DatePicker']}>
                                      <DatePicker
                                        sx={{ width: '100%' }}
                                        // label="Start Available"
                                        label="Data inizio prevista"
                                        value={dateStart}
                                        onChange={handleDateStartChange}

                                      />
                                    </DemoContainer>
                                  </LocalizationProvider>
                                </FormControl>
                              </MDBox>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                              <MDBox mt={mtValue2}>
                                <FormControl fullWidth>
                                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                    <DemoContainer components={['DatePicker']}>
                                      <DatePicker
                                        sx={{ width: '100%' }}
                                        // label="End Available"
                                        label="Data fine prevista"
                                        value={dateEnd}
                                        onChange={handleDateEndChange}
                                      />
                                    </DemoContainer>
                                  </LocalizationProvider>
                                </FormControl>
                              </MDBox>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                              <MDBox mt={mtValue3}>
                                <TextField
                                  fullWidth
                                  // label="Location"
                                  label="Location"
                                  variant="outlined"
                                  value={location}
                                  onChange={handleChange(setLocation)}
                                />
                              </MDBox>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                              <MDBox mt={mtValue2}>
                                <TextField
                                  fullWidth
                                  // label="Experience Years"
                                  label="Anni esperienza"
                                  variant="outlined"
                                  type="number"
                                  value={experienceYears}
                                  onChange={handleChange(setExperienceYears)}
                                />
                              </MDBox>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4}>
                              <MDBox mt={mtValue2}>
                                <TextField
                                  fullWidth
                                  // label="Daily Rate"
                                  label="Rate giornaliero"
                                  variant="outlined"
                                  type="number"
                                  value={dailyRate}
                                  onChange={handleChange(setDailyRate)}
                                />
                              </MDBox>
                            </Grid>


                            <Grid item xs={12} sm={6} md={4} style={{ display: 'none' }}>
                              <MDBox mt={2}>
                                <FormControl fullWidth>
                                  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                    <DatePicker
                                      label="Publish Date"
                                      value={publishDate}
                                      onChange={handlePublishDateChange}
                                      sx={{ width: '100%' }}
                                    />
                                  </LocalizationProvider>
                                </FormControl>
                              </MDBox>
                            </Grid>

                            <Grid item xs={12} sm={2} >
                              <MDBox mt={mtValue2}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={fullRemote}
                                      onChange={handleCheckboxChange(setFullRemote)}
                                      sx={{
                                        '&.Mui-checked .MuiSvgIcon-root': {
                                          backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), linear-gradient(195deg, #344767, #344767)`,
                                          borderColor: '#344767',
                                        },
                                      }}
                                    />}
                                  label="Full Remote"
                                />
                              </MDBox>
                            </Grid>

                            <Grid item xs={12} sm={2} >
                              <MDBox mt={mtValue2}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={longTerm}
                                      onChange={handleCheckboxChange(setLongTerm)}
                                      sx={{
                                        '&.Mui-checked .MuiSvgIcon-root': {
                                          backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), linear-gradient(195deg, #344767, #344767)`,
                                          borderColor: '#344767',
                                        },
                                      }}
                                    />}
                                  // label="Long Term"
                                  label="Lungo termine"
                                />
                              </MDBox>
                            </Grid>

                          </>

                        ) : ''}

                        {/* {!selectItDev && (

                          <>

                            <Grid item xs={12} sm={6} md={4} style={shouldHide}>
                              <MDBox mt={3}>
                                <FormControl fullWidth>
                                  <TextField
                                    label="test"
                                    variant="outlined"
                                    
                                  />
                                </FormControl>
                              </MDBox>
                            </Grid>

                            <Grid item xs={12} sm={6} md={4} style={shouldHide}>
                              <MDBox mt={3}>
                                <FormControl fullWidth>
                                  <TextField
                                    label="test"
                                    variant="outlined"
                                    
                                  />
                                </FormControl>
                              </MDBox>
                            </Grid>

                          </>

                        )} */}

                        {/* Other existing fields */}

                        {/* New Attachment Field */}

                        { IsAdminPlatform === 1 && 
                        (
                          <Grid item xs={12}>
                            <Grid item xs={12} sm={6} md={12}>
                              <MDBox mt={mtValue2}>
                                <FormControl fullWidth>
                                  <InputLabel htmlFor="attachment" shrink>
                                    Allegato
                                  </InputLabel>
                                  <Input
                                    id="attachment"
                                    type="file"
                                    onChange={handleFileChange} // Handle the file change
                                    inputProps={{ accept: ".pdf,.mp4,.jpg,.png" }} // Restrict file types
                                    sx={{
                                      "& input": {
                                        padding: "5px 14px", // Adjust the input padding if needed
                                      },
                                    }}
                                  />
                                  {attachment && (
                                    <Typography sx={{ marginTop: 1 }}>
                                      File selected: {attachment.name} {/* Display file name if selected */}
                                    </Typography>
                                  )}
                                </FormControl>
                              </MDBox>
                            </Grid>
                            <Grid item xs={12}>
                              <MDBox mt={2}>
                                <FormControl fullWidth>
                                  <TextField
                                    type="url"
                                    label="Collegamento URL"
                                    variant="outlined"
                                    
                                    value={linkUrl}
                                    onChange={(e)=>{ console.log(e.target.value); setlinkUrl(e.target.value); }}
                                  />
                                </FormControl>
                              </MDBox>
                            </Grid>

                            <Grid item xs={12}>
                              <MDBox mt={2}>
                                <FormControl fullWidth>
                                  <TextField
                                    // label="Description"
                                    label="Descrizione del collegamento"
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    value={linkDescription}
                                    onChange={(e)=>{ console.log(e.target.value); setlinkDescription(e.target.value); }}
                                  />
                                </FormControl>
                              </MDBox>
                            </Grid>
                          </Grid>
                        )

                        }  

                        <Grid item xs={12}>
                          <MDBox mt={2}>
                            <FormControl fullWidth>
                              <TextField
                                // label="Description"
                                label="Descrizione"
                                variant="outlined"
                                multiline
                                rows={4}
                                value={description}
                                onChange={handleChange(setDescription)}
                              />
                            </FormControl>
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} >
                          <MDBox mt={3}>
                            <Stack spacing={2} mb={2} direction="row" justifyContent="flex-end">
                              {/* <Button variant="contained" onClick={handleSubmit}>
                                {isSubmitting ? <a style={{ color: 'white' }}>Submitting...</a> :
                                  // <a style={{ color: 'white' }}>Save</a>
                                  <a style={{ color: 'white' }}>Salva</a>

                                }

                              </Button> */}

                              <Button
                                variant="contained"
                                onClick={handleSubmit}
                                sx={{
                                  backgroundColor: '#183759',
                                  '&:hover': {
                                    backgroundColor: '#204b80', // Subtle hover shade
                                  },
                                  transition: 'background-color 0.3s ease-in-out',
                                  // textTransform: 'none'
                                }}
                              >
                                {isSubmitting ? (
                                  <a style={{ color: 'white', textDecoration: 'none' }}>Submitting...</a>
                                ) : (
                                  <a style={{ color: 'white', textDecoration: 'none' }}>Salva</a>
                                )}
                              </Button>


                            </Stack>
                          </MDBox>
                        </Grid>
                      </Grid>

                      {/* Display Success/Error Messages */}
                      {successMessage && (
                        <Grid item xs={12}>
                          <MDBox mt={3} style={{ color: 'green' }}>
                            <MDTypography>{successMessage}</MDTypography>
                          </MDBox>
                        </Grid>
                      )}
                      {errorMessage && (
                        <Grid item xs={12}>
                          <MDBox mt={3} style={{ color: 'red' }}>
                            <MDTypography color="error" variant="body1" style={{ fontWeight: 'bold' }}>{errorMessage}</MDTypography>
                          </MDBox>
                        </Grid>
                      )}

                    </Grid>

                  </MDBox>
                )}
              </Box>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {/* Delete Confirmation Dialog */}
      <Dialog open={openDeleteDialog} onClose={handleDeleteDialogClose} fullWidth maxWidth="sm">
        {/* <DialogTitle>Confirm Deletion</DialogTitle> */}
        <DialogTitle>Conferma l'eliminazione</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {/* Are you sure you want to delete this request? This action cannot be undone. */}
            Sei sicuro di voler eliminare questa richiesta? Questa azione non può essere annullata.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose} color="primary">
            {/* Cancel */}
            Annulla
          </Button>
          <Button onClick={handleDeleteConfirm} color="error">
            Cancella
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Confirmation Dialog */}
      {/* <Dialog open={openEditDialog} onClose={handleEditDialogClose} fullWidth maxWidth="sm">
        <DialogTitle>Edit Request</DialogTitle>
        <DialogContent>
          <TextField
            label="Request Name"
            variant="outlined"
            fullWidth
            value={requestName}
            onChange={(e) => setRequestName(e.target.value)}
            error={!!errors.name}
            helperText={errors.name}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2, mt: 2 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditDialogClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleEditSubmit} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog> */}


      {/* Edit Confirmation Dialog Modify */}
      <Dialog open={openEditDialog} onClose={handleEditDialogClose} fullWidth maxWidth="md">
        {/* <DialogTitle>Edit Request</DialogTitle>  */}
        <DialogTitle>Modifica richiesta</DialogTitle>
        <DialogContent sx={{ paddingBottom: 3 }}>
          {/* Request Name Field */}
          {/* <TextField
            label="Title"
            variant="outlined"
            fullWidth
            value={requestName}
            onChange={(e) => setRequestName(e.target.value)}
            error={!!errors.name}
            helperText={errors.name}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2,mt:2 }}
          /> */}

          {/* <FormControl fullWidth sx={{ marginBottom: 2, mt: 2 }}>
            <InputLabel id="type-select-label1">It Dev</InputLabel>
            <Select
              labelId="type-select-label1"
              id="type-select"
              value={selectItDev ? 1 : 2}
              label="It Dev"
              onChange={handleItDevChange}
              style={{ height: 45 }}
              sx={{
                '& .MuiSelect-icon': {
                  display: 'block !important',  // Force icon to be visible
                  fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                },
              }}
              IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed
            >
              {isLoading ? (
                <MenuItem disabled>
                  <CircularProgress size={24} sx={{ mr: 1 }} />
                  Loading...
                </MenuItem>
              ) : itDev.length > 0 ? (
                itDev.map((type) => (
                  <MenuItem key={type.id} value={type.id}>
                    {type.name}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No It Dev available</MenuItem>
              )}
            </Select>
          </FormControl> */}


          {/* Request Type Field */}
          <FormControl fullWidth sx={{ marginBottom: 2, mt: 2 }}>
            {/* <InputLabel id="type-select-label">Request Type</InputLabel> */}
            <InputLabel id="type-select-label">Tipologia</InputLabel>
            <Select
              labelId="type-select-label"
              id="type-select"
              value={type}
              label="Request Type"
              onChange={handleTypeChange}
              style={{ height: 45 }}
              sx={{
                '& .MuiSelect-icon': {
                  display: 'block !important',  // Force icon to be visible
                  fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                },
              }}
              IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed
            >
              {isLoading ? (
                <MenuItem disabled>
                  <CircularProgress size={24} sx={{ mr: 1 }} />
                  Loading...
                </MenuItem>
              ) : requestTypes.length > 0 ? (
                requestTypes.map((type) => (
                  <MenuItem key={type.IdRequestType} value={type.IdRequestType}>
                    {type.RequestType}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No request types available</MenuItem>
              )}
            </Select>
          </FormControl>

          {/* Company Field */}
          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            {/* <InputLabel id="company-select-label">Company</InputLabel> */}
            <InputLabel id="company-select-label">Azienda</InputLabel>
            <Select
              labelId="company-select-label"
              id="company-select"
              value={company}
              label="Company"
              onChange={handleCompanyChange}
              style={{ height: 45 }}
              sx={{
                '& .MuiSelect-icon': {
                  display: 'block !important',  // Force icon to be visible
                  fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                },
              }}
              IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed
            >
              {isLoading ? (
                <MenuItem disabled>
                  <CircularProgress size={24} sx={{ mr: 1 }} />
                  Loading...
                </MenuItem>
              ) : companies.length > 0 ? (
                companies.map((comp) => (
                  <MenuItem key={comp.IdCompany} value={comp.IdCompany}>
                    {comp.CompanyName}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No companies available</MenuItem>
              )}
            </Select>
          </FormControl>

          {/* Category Field */}
          <FormControl fullWidth sx={{ marginBottom: 2 }}>
            {/* <InputLabel id="category-select-label">Category</InputLabel> */}
            <InputLabel id="category-select-label">Categoria</InputLabel>
            <Select
              labelId="category-select-label"
              id="category-select"
              value={category}
              label="Category"
              onChange={handleCategoryChange}
              style={{ height: 45 }}
              sx={{
                '& .MuiSelect-icon': {
                  display: 'block !important',  // Force icon to be visible
                  fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                },
              }}
              IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed

            >
              {isLoading ? (
                <MenuItem disabled>
                  <CircularProgress size={24} sx={{ mr: 1 }} />
                  Loading...
                </MenuItem>
              ) : categories.length > 0 ? (
                categories.filter(cat => cat.show_in_filter != 0 ).map((cat) => (
                  <MenuItem key={cat.IdRequestCategory} value={cat.IdRequestCategory}>
                    {cat.RequestCategory}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No categories available</MenuItem>
              )}
            </Select>
          </FormControl>



          {/* <FormControl fullWidth sx={{ marginBottom: 2 }}>
            <InputLabel id="type-select-label1">It Dev</InputLabel>
            <Select
              labelId="type-select-label1"
              id="type-select"
              value={selectItDev ? 1 : 2}
              label="It Dev"
              onChange={handleItDevChange}
              style={{ height: 45 }}
              sx={{
                '& .MuiSelect-icon': {
                  display: 'block !important',  // Force icon to be visible
                  fontSize: '1.6rem !important',  // Adjust the size of the dropdown icon
                },
              }}
              IconComponent={ArrowDropDownIcon}  // Ensures the dropdown icon is displayed
            >
              {isLoading ? (
                <MenuItem disabled>
                  <CircularProgress size={24} sx={{ mr: 1 }} />
                  Loading...
                </MenuItem>
              ) : itDev.length > 0 ? (
                itDev.map((type) => (
                  <MenuItem key={type.id} value={type.id}>
                    {type.name}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>No It Dev available</MenuItem>
              )}
            </Select>
          </FormControl> */}

          {/* Request Name Field */}
          <TextField
            // label="Title"
            label="Titolo"
            variant="outlined"
            fullWidth
            value={requestName}
            onChange={(e) => setRequestName(e.target.value)}
            error={!!errors.name}
            helperText={errors.name}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2, }}
          />

          {selectItDev ? (

            <>

              {/* Start Date */}
              <FormControl fullWidth sx={{ marginBottom: 2 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                  <DemoContainer components={['DatePicker']}>
                    <DatePicker
                      sx={{ width: '100%' }}
                      // label="Start Available"
                      label="Data inizio prevista"
                      value={dateStart ? dayjs(dateStart) : null}
                      onChange={handleDateStartChange}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </FormControl>

              {/* End Date */}
              <FormControl fullWidth sx={{ marginBottom: 2 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                  <DemoContainer components={['DatePicker']}>
                    <DatePicker
                      sx={{ width: '100%' }}
                      // label="End Available"
                      label="Data fine prevista"
                      value={dateEnd ? dayjs(dateEnd) : null}
                      onChange={handleDateEndChange}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              </FormControl>

              {/* Location */}
              <TextField
                fullWidth
                // label="Location" 
                label="Luogo"
                variant="outlined"
                value={location}
                onChange={handleChange(setLocation)}
                sx={{ marginBottom: 2 }}
              />

              {/* Experience Years */}
              <TextField
                fullWidth
                // label="Experience Years"
                label="Esperienza (Anni)"
                variant="outlined"
                type="number"
                value={experienceYears}
                onChange={handleChange(setExperienceYears)}
                sx={{ marginBottom: 2 }}
              />

              {/* Daily Rate */}
              <TextField
                fullWidth
                // label="Daily Rate"
                label="Rate giornaliero"
                variant="outlined"
                type="number"
                value={dailyRate}
                onChange={handleChange(setDailyRate)}
                sx={{ marginBottom: 2 }}
              />

              {/* Full Remote Checkbox */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={fullRemote}
                    onChange={handleCheckboxChange(setFullRemote)}
                    sx={{
                      '&.Mui-checked .MuiSvgIcon-root': {
                        backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), linear-gradient(195deg, #344767, #344767)`,
                        borderColor: '#344767',
                      },
                    }}

                  />
                }
                // label="Full Remote"
                label="Full Remote"
                sx={{ marginBottom: 2 }}
              />

              {/* Long Term Checkbox */}
              <FormControlLabel
                control={
                  <Checkbox
                    checked={longTerm}
                    onChange={handleCheckboxChange(setLongTerm)}
                    sx={{
                      '&.Mui-checked .MuiSvgIcon-root': {
                        backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -1 22 22'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='2.5' d='M6 10l3 3l6-6'/%3e%3c/svg%3e"), linear-gradient(195deg, #344767, #344767)`,
                        borderColor: '#344767',
                      },
                    }}

                  />
                }
                // label="Long Term"
                label="Lungo periodo"
                sx={{ marginBottom: 2 }}
              />

              {/* Publish Date */}
              <FormControl fullWidth sx={{ marginBottom: 2 }}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                  <DatePicker
                    // label="Publish Date"
                    label="Data pubblicazione"
                    value={publishDate ? dayjs(publishDate) : null}
                    onChange={handlePublishDateChange}
                    sx={{ width: '100%', }}
                    disabled
                  />
                </LocalizationProvider>
              </FormControl>

            </>

          ) : ''}

          { IsAdminPlatform === 1 && 
              ( 
                <Grid>
                  {/* Attachment Field */}
                  <FormControl fullWidth sx={{ marginBottom: 3 }}>
                    <InputLabel htmlFor="attachment" shrink>
                      Allegato
                    </InputLabel>
                    <Input
                      inputRef={inputFile}
                      id="attachment"
                      type="file"
                      onChange={handleFileChange}
                      inputProps={{ accept: ".pdf,.mp4,.jpg,.png" }} // You can restrict file types here
                      sx={{
                        "& input": {
                          padding: "5px 14px", // Adjust the input padding if needed
                        },
                      }}
                    />
                    {(attachment || oldattachment) && (
                      // <div style={{ marginTop: 5, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                      //   <span>File selezionato:</span> {attachment ? attachment.name : (<a href="javascript: void(0);" onClick={() => window.open(`${fileUploadUrl}/${oldattachment}`, '_blank')} target="_blank"><AttachFileIcon fontSize={"20"} sx={{color: '#006bd6', display: 'flex', justifyContent: 'center', alignItems: 'center'}} /></a>)}
                      // </div>
                      <div style={{ marginTop: 5, display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <span>File selezionato:</span> <a href="javascript: void(0);" onClick={() => window.open(`${fileUploadUrl}/${oldattachment}`, '_blank')} target="_blank"><AttachFileIcon fontSize={"20"} sx={{color: '#006bd6', display: 'flex', justifyContent: 'center', alignItems: 'center'}} /></a>
                      </div>
                    )}
                  </FormControl>

                  {/* Link Url */}
                  <TextField
                    type="url"
                    fullWidth
                    label="Collegamento URL"
                    variant="outlined"
                    value={linkUrl}
                    onChange={(e)=>{ console.log(e.target.value); setlinkUrl(e.target.value); }}
                    sx={{ marginBottom: 3 }}
                  />

                  {/* Link Description */}
                  <TextField
                    fullWidth
                    label="Descrizione del collegamento"
                    variant="outlined"
                    multiline
                    rows={3}
                    value={linkDescription}
                    onChange={(e)=>{ 
                      // console.log(e.target.value); 
                      setlinkDescription(e.target.value); 
                    }}
                    sx={{ marginBottom: 3 }}
                  />
                </Grid>
            )
          }
          {/* Description */}
          <TextField
            fullWidth
            // label="Description"
            label="Descrizione"
            variant="outlined"
            multiline
            rows={4}
            value={description}
            onChange={handleChange(setDescription)}
            sx={{ marginBottom: 3 }}
          />

          


        </DialogContent>

        <DialogActions>
          <Button onClick={handleEditDialogClose} color="primary">
            {/* Cancel */}
            Annulla
          </Button>
          <Button onClick={handleEditSubmit} color="primary">
            {/* Save */}
            Salva
          </Button>
        </DialogActions>
      </Dialog>


    </DashboardLayout>
  );

}

export default Tables;
